import {isHexColor, hexToHSL} from "@/scripts/common/helpers.js";

const getPaletteColorIndex = (newColor, colorPaletteColors, paletteIndex) => {
    if (paletteIndex !== undefined && paletteIndex !== null) {
        return paletteIndex;
    }
    const indexInPalette = colorPaletteColors.indexOf(newColor);
    return indexInPalette !== -1 ? indexInPalette : null;

};

const updateColorObject = (colorObject, colorValue, paletteIndex) => {
    colorObject.primaryColor = colorValue;
    colorObject.secondaryColor = colorValue;
    colorObject.color = colorValue;
    colorObject.paletteColorIndex = paletteIndex;
};

const applyColor = (colorObject, colorPaletteColors, newColor, paletteIndex) => {
    if (isHexColor(newColor)) {
        const calculatedIndex = getPaletteColorIndex(newColor, colorPaletteColors, paletteIndex);
        updateColorObject(colorObject, newColor, calculatedIndex);
    } else {
        const paletteColor = colorPaletteColors[newColor];
        updateColorObject(colorObject, paletteColor, newColor);
    }
    return colorObject;
};

export function updateSimpleColorGroup(colorStyles, colorPalette, color, clusterItems) {
    const colorPaletteColors = colorPalette.COLORS ? colorPalette.COLORS : colorPalette.colors;

    const updatedColorStyles = {};

    clusterItems.forEach(item => {
        const colorObject = colorStyles[item];

        if (!colorObject) {
            console.error(`Color object not found for subtype: ${item}`);
            return;
        }

        const updatedColorObject = {...colorObject};

        updatedColorStyles[item] = applyColor(updatedColorObject, colorPaletteColors, color);
    });

    return updatedColorStyles
}

export function  updateRuleBasedColorGroup(colorStyles, colorPalette, color, clusterItems, colorRules) {
    const colorPaletteColors = colorPalette.COLORS ? colorPalette.COLORS : colorPalette.colors;

    const updatedColorStyles = {};

    const getBackgroundColor = (colorRule) => {
        const foregroundItemHasBackgroundColor = colorRules.fill?.default === "selected"
        const bgColorIndex = colorStyles.background.paletteColorIndex !== undefined && colorStyles.background.paletteColorIndex !== null
            ? colorStyles.background.paletteColorIndex
            : colorStyles.background.primaryColor
                ? colorStyles.background.primaryColor
                : colorPalette.COLOR_MAP.BACKGROUND.colorIndex

        if(colorRule.relativeToKey) {
            return colorStyles[colorRule.relativeToKey]?.paletteColorIndex !== undefined && colorStyles[colorRule.relativeToKey]?.paletteColorIndex !== null
                ? colorPaletteColors[colorStyles[colorRule.relativeToKey].paletteColorIndex]
                : colorStyles[colorRule.relativeToKey]?.color
                || colorPaletteColors[colorStyles["background"].paletteColorIndex]
                || colorStyles["background"]?.color
        } else {
            return foregroundItemHasBackgroundColor && colorRule.state === "idle"
                ? isHexColor(color)
                    ? color
                    : colorPaletteColors[color]
                : bgColorIndex && !isHexColor(bgColorIndex)
                    ? colorPaletteColors[bgColorIndex]
                    : colorStyles.background.color
        }
    };

    Object.entries(clusterItems).forEach(([key, value]) => {
        const colorObject = colorStyles[key]

        // if (!colorObject) {
        //     console.error(`Color object not found for subtype: ${key}`);
        //     return;
        // }

        const updatedColorObject = {...colorObject};

        let newColor = color;
        let newPaletteColorIndex = !isHexColor(color) && colorPaletteColors.indexOf(color) > -1
            ? colorPaletteColors.indexOf(color) > -1
            : null;

        if (value.colorRule && value.colorRule.default !== "selected") {

            if (value.colorRule.colorStyleKey) {
                const keyBasedObject = colorStyles[value.colorRule.colorStyleKey];
                newColor = keyBasedObject.paletteColorIndex
                    ? colorPaletteColors[keyBasedObject.paletteColorIndex]
                    : keyBasedObject.color;
                newPaletteColorIndex = keyBasedObject.paletteColorIndex;
            }

            if (["contrast", "vibrant"].includes(value.colorRule.default)) {
                const backgroundColor = getBackgroundColor(value.colorRule);
                const bestColor = getBestColor(backgroundColor, colorPaletteColors, value.colorRule);
                newColor = bestColor.color;
                newPaletteColorIndex = bestColor.index;
            }
        }

        updatedColorStyles[key] = applyColor(updatedColorObject, colorPaletteColors, newColor, newPaletteColorIndex);
    });

    return updatedColorStyles
}

//// NEW UTILS
const NEW_updateColorObject = (colorObject, colorValue, paletteIndex, colorStyle, colorState) => {
    colorObject.primaryColor = colorValue;
    colorObject.secondaryColor = colorValue;
    colorObject.color = colorValue;
    colorObject.paletteColorIndex = paletteIndex > -1 ? paletteIndex : null;

    if (!colorObject[colorStyle]) {
        colorObject[colorStyle] = {};
    }
    colorObject[colorStyle][colorState] = {
        color: colorValue,
        paletteColorIndex: paletteIndex > -1 ? paletteIndex : null,
    };
};

const NEW_applyColor = (colorObject, colorPaletteColors, newColor, paletteIndex, colorStyle, colorState) => {
    if (isHexColor(newColor)) {
        const calculatedIndex = getPaletteColorIndex(newColor, colorPaletteColors, paletteIndex);
        NEW_updateColorObject(colorObject, newColor, calculatedIndex, colorStyle, colorState);
    } else {
        const paletteColor = colorPaletteColors[newColor];
        NEW_updateColorObject(colorObject, paletteColor, newColor, colorStyle, colorState);
    }
    return colorObject;
};

export function NEW_updateSimpleColorGroup(colors, colorPalette, color, colorMap) {
    const colorPaletteColors = colorPalette.COLORS ? colorPalette.COLORS : colorPalette.colors;

    const updatedColors = {};

    colorMap.clusterItems.forEach(item => {
        const colorObject = colors[item];
        if (!colorObject) {
            console.error(`Color object not found for subtype: ${item}`);
            return;
        }

        const updatedColorObject = {...colorObject};
        updatedColors[item] = NEW_applyColor(
            updatedColorObject,
            colorPaletteColors,
            color,
            null,
            colorMap.colorTypeToSet,
            'idle'
        );
    });

    return updatedColors
}

export function NEW_updateRuleBasedColorGroup(colors, colorPalette, color, colorMap, useColorAsBackgroundColor = false, foregroundColor = null) {
    const colorPaletteColors = colorPalette.COLORS ? colorPalette.COLORS : colorPalette.colors;
    let updatedColors = {};
    updatedColors[colorMap.clusterName] = {
        ...colors[colorMap.clusterName]
    }

    const getBackgroundColor = (colorState, colorRule, colorTypes) => {
        const defaultPaletteIndex = 4;

        const hasForegroundBackgroundColor =
            colorTypes.fill?.colorRule?.default === "selected";

        const backgroundFill = colors.background.fill.idle;
        const bgColorIndex = backgroundFill.paletteColorIndex ?? defaultPaletteIndex;

        // If the color should be derived from another key
        if (colorRule.relativeToKey) {
            const { type, state } = colorRule.relativeToKey;
            const dependentStyle = updatedColors[colorMap.clusterName]?.[type]?.[state];

            if (dependentStyle) {
                const { paletteColorIndex, color } = dependentStyle;
                return paletteColorIndex != null
                    ? colorPaletteColors[paletteColorIndex]
                    : color;
            }

            return colorPaletteColors[defaultPaletteIndex];
        }

        if (hasForegroundBackgroundColor && colorState === "idle") {
            return isHexColor(color)
                ? color
                : colorPaletteColors[color];
        }

        return colorPaletteColors[bgColorIndex] ?? colors.background.color;
    };

    const typeProcessingOrder = ['fill', 'outline', 'text'];

    typeProcessingOrder.forEach((colorTypeKey) => {
        const colorType = colorMap.colorTypes[colorTypeKey];
        if(!colorType) {
            updatedColors[colorMap.clusterName][colorTypeKey] = null;
            return
        }

        if(colorType.colorRule) {
            const stateProcessingOrder = ['idle', 'hover', 'active'];

            stateProcessingOrder.forEach((colorStateKey) => {
                const colorRule = colorType.colorRule[colorStateKey];
                if(!colorRule) {
                    if(updatedColors[colorMap.clusterName][colorTypeKey] && updatedColors[colorMap.clusterName][colorTypeKey][colorStateKey]) {
                        updatedColors[colorMap.clusterName][colorTypeKey][colorStateKey] = null;
                    }
                    return
                }

                let newColor = !foregroundColor ? color : foregroundColor;
                let newPaletteColorIndex = !isHexColor(color)
                    ? color
                    : colorPaletteColors.includes(color)
                        ? colorPaletteColors.indexOf(color)
                        : null;

                if (colorRule.default !== "selected") {
                    if (colorRule.colorStyleDependency) {
                        const colorDependency = colors[colorRule.colorStyleDependency.key][colorRule.colorStyleDependency.type][colorRule.colorStyleDependency.state];
                        newColor = colorDependency.paletteColorIndex
                            ? colorPaletteColors[colorDependency.paletteColorIndex]
                            : colorDependency.color;
                        newPaletteColorIndex = colorDependency.paletteColorIndex;
                    }

                    if (["contrast", "vibrant"].includes(colorRule.default)) {
                        const backgroundColor = !useColorAsBackgroundColor ? getBackgroundColor(colorStateKey, colorRule, colorMap.colorTypes) : color;
                        const bestColor = getBestColor(backgroundColor, colorPaletteColors, colorRule);
                        newColor = bestColor.color;
                        newPaletteColorIndex = bestColor.index;
                    }
                }

                // overwrite filled items text color in sections
                if(foregroundColor && colorRule.default === 'background') {

                    newColor = color;
                    newPaletteColorIndex = colorPaletteColors.indexOf(newColor);

                    if(colorRule.fallbacks) {
                        const backgroundColor = getBackgroundColor(colorStateKey, colorRule, colorMap.colorTypes);
                        const cr = contrastRatio(hexToRgb(backgroundColor), hexToRgb(color));

                        if(cr < 4) {
                            const bestColor = getBestColor(backgroundColor, colorPaletteColors, colorRule);
                            newColor = bestColor.color;
                            newPaletteColorIndex = bestColor.index
                        }
                    }

                }

                if(foregroundColor && colorRule.default === 'selected') {
                    newColor = foregroundColor;
                    newPaletteColorIndex = colorPaletteColors.indexOf(newColor);
                }

                updatedColors[colorMap.clusterName] = {
                    ...NEW_applyColor(
                        updatedColors[colorMap.clusterName],
                        colorPaletteColors,
                        newColor,
                        newPaletteColorIndex,
                        colorTypeKey,
                        colorStateKey
                    )
                };

            })
        }

    });

    return updatedColors
}

function recursivelyUpdateColors(obj, newColorIndex, newColor, backgroundColor, colorGroupsWithDifferentRules, colorPalette) {
    const updated = Array.isArray(obj) ? [] : {};

    for (const key in obj) {
        if (!obj.hasOwnProperty(key)) continue;

        const value = obj[key];

        if (key === 'paletteColorIndex') {
            updated[key] = newColorIndex > -1 ? newColorIndex : null;
        } else if (key === 'color') {
            updated[key] = newColorIndex < 0 ? newColor : null;
        } else if (typeof value === 'object' && value !== null) {
            if (colorGroupsWithDifferentRules[key]?.colorMap) {
                updated[key] = {
                    ...NEW_updateRuleBasedColorGroup(
                        obj, colorPalette, backgroundColor, colorGroupsWithDifferentRules[key].colorMap, true, newColor
                    )[key]
                };
            } else {
                updated[key] = recursivelyUpdateColors(value, newColorIndex, newColor, backgroundColor, colorGroupsWithDifferentRules, colorPalette);
            }
        } else {
            updated[key] = value;
        }
    }

    return updated;
}

export function setAutoColorForSectionForegroundItems(foregroundColors, backgroundColor, colorPalette, colorGroupsWithDifferentRules) {
    const bestColor = getBestColor(backgroundColor, colorPalette.colors);

    return recursivelyUpdateColors(foregroundColors, bestColor.index, bestColor.color, backgroundColor, colorGroupsWithDifferentRules, colorPalette);
}

export function setCustomColorForSectionForegroundItems(foregroundColors, backgroundColor, newColor, newColorIndex, colorPalette, colorGroupsWithDifferentRules) {
    return recursivelyUpdateColors(foregroundColors, newColorIndex, newColor, backgroundColor, colorGroupsWithDifferentRules, colorPalette);
}

export function resolveNonHexColor(value, colorPalette) {
    return isHexColor(value)
        ? value
        : colorPalette.colors[getPaletteColorIndexFromString(value)];
}

export function resolveControlBackgroundColor(backgroundColor, colorPalette) {
    if (!backgroundColor) return null;

    if (typeof backgroundColor === 'object') {
        if (!!backgroundColor.paletteColorIndex) {
            return colorPalette.colors[backgroundColor.paletteColorIndex];
        }

        return backgroundColor.color || backgroundColor.primaryColor || null;
    }

    return typeof backgroundColor === 'string' && backgroundColor.startsWith('paletteColorIndex:')
        ? resolveNonHexColor(backgroundColor, colorPalette)
        : backgroundColor;
}

export function getControlThemeClass(backgroundColor, colorPalette, classPrefix = "ui-controls") {
    const resolvedBackgroundColor = resolveControlBackgroundColor(backgroundColor, colorPalette);
    const isDark = resolvedBackgroundColor ? isHexColorDark(resolvedBackgroundColor) : false;
    return isDark ? `${classPrefix}--dark` : `${classPrefix}--light`;
}

export function getPaletteColorIndexFromString(value) {
    if (typeof value === 'string' && value.startsWith('paletteColorIndex:')) {
        return parseInt(value.split(':')[1], 10);
    }
    return -1;
}

// Utility functions to calculate luminance, contrast, and vibrancy
function luminance([r, g, b]) {
    const a = [r, g, b].map(v => {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

function contrastRatio(rgb1, rgb2) {
    const lum1 = luminance(rgb1) + 0.05;
    const lum2 = luminance(rgb2) + 0.05;
    return lum1 > lum2 ? lum1 / lum2 : lum2 / lum1;
}

function hexToRgb(hex) {
    if(!hex) {
        return
    }

    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, (_, r, g, b) => r + r + g + g + b + b);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
    ] : null;
}

function rgbToHex({ r, g, b }) {
    return (
        '#' +
        [r, g, b]
            .map(x => {
                const hex = x.toString(16);
                return hex.length === 1 ? '0' + hex : hex;
            })
            .join('')
    );
}

function saturation([r, g, b]) {
    const max = Math.max(r, g, b) / 255;
    const min = Math.min(r, g, b) / 255;
    return max === 0 ? 0 : (max - min) / max;
}

function brightness([r, g, b]) {
    // return (r * 0.299 + g * 0.587 + b * 0.114); // Standard brightness formula
    return (r * 299 + g * 587 + b * 114) / 1000 / 255;
}

function brightnessDifference(backgroundRgb, rgb) {
    return Math.abs(brightness(backgroundRgb) - brightness(rgb));
}

export function isHexColorDark(hex) {
    if (!hex) {
        return false;
    }
    try {
        const { l } = hexToHSL(hex);
        return l < 0.2;
    } catch (e) {
        return false;
    }
}

export function mixColors(color1, color2, ratio = 0.5) {
    const rgb1 = hexToRgb(color1);
    const rgb2 = hexToRgb(color2);
    const mix = {
        r: Math.round(rgb1[0] * (1 - ratio) + rgb2[0] * ratio),
        g: Math.round(rgb1[1] * (1 - ratio) + rgb2[1] * ratio),
        b: Math.round(rgb1[2] * (1 - ratio) + rgb2[2] * ratio),
    };
    return rgbToHex(mix);
}


// Method to get the best color for contrast/vibrancy against a background color
export function getBestColor(backgroundColor, palette, colorRule = { default: 'contrast' }, contrastThreshold = 4) {
    const backgroundRgb = hexToRgb(backgroundColor);
    if (!backgroundRgb) return null;

    let bestResult = { color: null, index: -1, type: null };
    let bestScore = colorRule.default === 'contrast' ? 0 : -Infinity;

    const colorRules = [colorRule.default, ...(colorRule.fallbacks || [])];

    for (const rule of colorRules) {

        palette.forEach((color, index) => {
            if (color.toLowerCase() === backgroundColor.toLowerCase()) return;

            const rgb = hexToRgb(color);
            if (!rgb) return;

            let score;
            if (rule === 'contrast') {
                score = contrastRatio(backgroundRgb, rgb);
            } else if (rule === 'vibrant') {
                score = brightnessDifference(backgroundRgb, rgb);
                // TODO this following calculation does not work well with muted and close in tones palettes (eg Chestnut)
                //const sat = saturation(rgb);
                //const bright = brightness(rgb);
                //score = sat * bright;
            }

            if (score > bestScore) {
                bestScore = score;
                bestResult = { color, index, type: rule };
            }
        });

        if (rule === 'contrast' && bestScore >= contrastThreshold) {
            bestResult.type = 'contrast';
            break;
        }

        if (bestResult.color) {
            break;
        }
    }

    // As a last resort, return black or white based on contrast
    if (!bestResult.color) {
        const blackContrast = contrastRatio(backgroundRgb, [0, 0, 0]);
        const whiteContrast = contrastRatio(backgroundRgb, [255, 255, 255]);
        bestResult.color = blackContrast > whiteContrast ? '#000000' : '#FFFFFF';
        bestResult.type = 'fallback';
    }

    return bestResult;
}

export function getLeastContrastColor(backgroundColor, palette) {
    const backgroundRgb = hexToRgb(backgroundColor);
    if (!backgroundRgb) return null;

    let bestResult = { color: null, index: -1 };
    let lowestScore = Infinity;

    palette.forEach((color, index) => {
        if (color.toLowerCase() === backgroundColor.toLowerCase()) return;

        const rgb = hexToRgb(color);
        if (!rgb) return;

        const score = contrastRatio(backgroundRgb, rgb);
        if (score < lowestScore) {
            lowestScore = score;
            bestResult = { color, index };
        }
    });

    return bestResult;
}

export function isImageDarkOptimized(imageUrl, pageBgColor, callback, sampleSize = 50) {
    const img = new Image();
    img.crossOrigin = 'Anonymous'; // Needed for CORS
    img.src = imageUrl;

    img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = sampleSize;
        canvas.height = sampleSize;

        // Set page background color on canvas to fix images with transparent bg
        ctx.fillStyle = pageBgColor; // e.g., '#ffffff'
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Draw downscaled image
        ctx.drawImage(img, 0, 0, sampleSize, sampleSize);

        const imageData = ctx.getImageData(0, 0, sampleSize, sampleSize).data;

        let dark = 0, light = 0;
        for (let i = 0; i < imageData.length; i += 4) {
            const r = imageData[i];
            const g = imageData[i + 1];
            const b = imageData[i + 2];

            const brightness = 0.299 * r + 0.587 * g + 0.114 * b;
            brightness < 128 ? dark++ : light++;
        }

        callback(dark > light);
    };

    img.onerror = () => {
        console.error('Failed to load image.');
        callback(null);
    };
}

export function hasLocalColorOverrides(sections) {
    const sectionOverrides = sections.some(
        s => !!s.designSettings?.colors && Object.keys(s.designSettings.colors).length > 0
    );
    const styleOverrides = !!document.querySelector('style[id^="dynamic-css-vars-for-"]');
    return sectionOverrides || styleOverrides;
}
